<template>
  <div class="comprehensive-form-container">
    <el-row :gutter="20">
      <el-col
        :lg="{ span: 12, offset: 6 }"
        :md="{ span: 20, offset: 2 }"
        :sm="{ span: 20, offset: 2 }"
        :xl="{ span: 12, offset: 6 }"
        :xs="24"
      >
        <el-form
          ref="form"
          class="demo-form"
          :label-position="labelPosition"
          label-width="220px"
          :model="form"
          :rules="rules"
        >
          <el-form-item label="appId" prop="appId">
            <el-input v-model.trim="form.appId" />
          </el-form-item>
          <el-form-item label="appKey" prop="appKey">
            <el-input v-model.trim="form.appKey" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('form')">
              保存
            </el-button>
            <el-button @click="resetForm('form')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getSaiYou, setSaiYou } from '@/api/super'
export default {
  name: 'SettingsSaiYou',
  data() {
    return {
      labelPosition: 'right',
      form: {
        appId: '',
        appKey: '',
      },
      rules: {
        // accessKey: [
        //   { required: true, message: '请输入accessKey', trigger: 'blur' },
        // ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      const ret = await getSaiYou()
      this.form.appId = ret && ret.basic && ret.basic.appId
      this.form.appKey = ret && ret.basic && ret.basic.appKey
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const form = Object.assign({},this.form)
          await setSaiYou({
            config: form,
          })
          this.getData()
          this.$message.success('保存赛邮配置成功')
        } else {
          this.$message.success('保存赛邮配置失败')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-form-item__content {
    .el-rate {
      display: inline-block;
      font-size: 0;
      line-height: 1;
      vertical-align: middle;
    }

    .el-transfer__buttons {
      padding: 10px 10px 0 10px;
    }
  }
}
.title {
  color: #c3c3c3;
  border-bottom: 1px solid #e3e3e3;
  padding-bottom: 10px;
}
</style>
